import axios from 'axios';
import {GET_WEATHER_DATA,GET_TIME} from '../constants/data'

export const getCurrentData2=(location,lat,lon)=>async(dispatch)=>{
    try{
    const {data} =  await axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${location}&lat=${lat}&lon=${lon}&lang=''&units=metric&APPID=${process.env.REACT_APP_API_KEY}`)
    const time = parseInt(new Date/1000);
    
    //const time2 = timestamp+data
    //console.log('UTC is'+time2)
    
    dispatch({type:GET_WEATHER_DATA,payload:data});
    dispatch({type:GET_TIME,payload:time})
    }
    catch(error){
        alert(error.message);
    }

}